import _ from 'underscore';
import { StatusIconColumn as BaseStatusIconColumn } from '@bingads-webui-campaign/campaignui-common-columns';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { inlineEditSave } from '@bingads-webui-campaign/summary-grid-helper';

const jsData = globalContext.require('component/js-data-campaign/index');
const i18nErrors = globalContext.require('component/api-errors-campaign/index');
const appConfig = globalContext.require('component/config/index');
const permissions = appConfig.get('Permissions');
const enableGridFlexLayout = _.result(permissions.dynamic, 'GridFlexLayout', false);

function resourceForAdType(type) {
  if (type === 'LinkedIn') {
    return jsData.ResponsiveAd;
  }
  return jsData[`${type}Ad`] || jsData.Ad;
}

export class StatusIconColumn extends BaseStatusIconColumn {
  constructor(options) {
    super(_.extend(options, {
      enableEdit: item => (item.Type !== 'Responsive' ||
        item.LandscapeImageMediaUrl !== null ||
        this.isPlaceholderMMA(item) ||
        _.result(item, 'Videos', []).length > 0),
      group: 'freezing',
      enableGridFlexLayout,
    }));

    this.isForVNext = options.isForVNext;
  }

  isPlaceholderMMA(item) {
    if (_.isEmpty(item.Headline) && _.isEmpty(item.Headlines) &&
      _.isEmpty(item.LongHeadline) && _.isEmpty(item.LongHeadlines) &&
      _.isEmpty(item.Text) && _.isEmpty(item.Descriptions)) {
      // placeholder MMA under the dynamic ad group
      return true;
    }
    return false;
  }

  updateStatus({ status, item }) {
    const additionalPayload = {
      AdGroup: {
        Id: _.result(item.AdGroup, 'Id', this.view.scope.adGroupId),
      },
    };

    if (item.Type === 'LinkedIn') {
      additionalPayload.AdType = 'LinkedIn';
    }

    return inlineEditSave(
      {
        id: item.Id,
        fieldName: 'Status',
        updatedItem: _.extend({}, item, { Status: status }),
        additionalPayload,
      },
      {
        view: this.view,
        resource: resourceForAdType(item.Type),
        scenario: 'NewAdsTab',
        i18n: this.i18n,
        i18nErrors,
        customBlockerTarget: this.isForVNext ? '.ads-page' : null,
      }
    );
  }
}
